import Checkbox from "../Checkbox"
import close from "../../assets/images/Close_SuccessPopup.svg";
import EventHandler from "../EventHandler";

const GetAttachmentView = (props: any) => {
    const { attachmentsList, onCloseLinkAttachment, onChangeLinkAttachment, itemType } = props
    return (
      <div className="tooltip-container">
        <div className='header'>
          <EventHandler onEvent={(e: any) => onCloseLinkAttachment(e)} data-attribute="index_Default_EventHandler_8">
            <img src={close} alt="" />
          </EventHandler>
        </div>
        <div className='content'>
          <div className="checkbox-list-container p-0">
            {
              attachmentsList?.length ? attachmentsList.map((attachment?: any) => (
                <div key={attachment?.fileName} className='checkbox-container'>
                  <Checkbox
                    label={attachment?.fileName}
                    className={"checkbox"}
                    title={attachment?.fileName}
                    defaultChecked={itemType?.attachments?.map((x: any) => x.fileName).includes(attachment?.fileName)}
                    onChange={(e: any) => { onChangeLinkAttachment(e, attachment, itemType) }}
                   data-attribute="index_Default_Checkbox" />
                </div>
              )) :
                <div className='checkbox-container text-center'>
                  No Attachment
                </div>
            }
          </div>
        </div>
      </div>
    )
  }

  export default GetAttachmentView